let inject = ['$scope', '$uibModalInstance'];

class PqrsResponsableModalController {
  constructor ($scope,$uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.comment = '';
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.comment);
  }
}

PqrsResponsableModalController.$inject = inject;

export default PqrsResponsableModalController;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-detail/pqrs-responsable-modal/pqrs-responsable-modal.controller.js
 **/